import { Component, OnChanges } from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ContactMethodType } from '../models/enums/contact-method-type.enum';
import { CustomerContact } from '../models/customer-contact.model';

@Component({
    selector: 'historical-customer-contact',
    templateUrl: './historical-customer-contact.html',
    inputs: ['customerNumberId']
})
export class HistoricalCustomerContactComponent extends BaseComponent implements OnChanges {
    public contacts: CustomerContact[];
    public customerNumberId: number;
    public cols: any[];

    private contactTypes: ContactMethodType = new ContactMethodType();

    constructor(private customerService: CustomerManageService) {
        super();

        this.cols = [
            { field: 'contactType', header: 'Type' },
            { field: 'customerContactValue', header: 'Value' },
            { field: 'isCorrespondenceEnabled', header: 'Text/Email Enabled' },
            { field: 'isPrimary', header: 'Primary' },
            { field: 'isPreferredContactMethod', header: 'Preferred Contact' },
            { field: 'isInvalid', header: 'Invalid' },
            { field: 'updatedDate', header: 'Updated' },
            { field: 'updatedBy', header: 'Updated By' }
        ];
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.contacts !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumberId != null) {
            this.populateHistoricalContacts(this.customerNumberId);
        }
    }

    populateHistoricalContacts(customerNumberId: number) {

        this.customerService.getHistoricalCustomerContacts(customerNumberId)
            .subscribe(result => {
                this.contacts = result;
            },
            e => {
                this.contacts = [];
                this.handleValidationResult(e);
            },
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const contact of this.contacts) {
            contact.contactType = this.getValues(contact.contactMethodTypeId, this.contactTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }
}
